import i1 from './006a.jpg';
import i1_t from './006a_thumb.jpg';
import i2 from './079.jpg';
import i2_t from './079_thumb.jpg';
import i3 from './123.jpg';
import i3_t from './123_thumb.jpg';
import i4 from './182a.jpg';
import i4_t from './182a_thumb.jpg';

const DEMO_IMAGES = [
  { full: i1, thumb: i1_t },
  { full: i2, thumb: i2_t },
  { full: i3, thumb: i3_t },
  { full: i4, thumb: i4_t },
];

export default DEMO_IMAGES;



// WEBPACK FOOTER //
// ./src/pages/commission/images/index.js